import React from 'react'
import { Dispatch } from 'redux'
import { Formik } from 'formik'
import { IGroupDetailed } from '../../types/group'
import { push } from '../../actions/router'
import { createGroup } from '../../actions/group'
import {
  transformRolesInputToState,
  transformRolesStateToInput,
} from '../../services/groups'
import { initialState } from '../../reducers/group'
import { groupValidationSchema } from './validation'
import { NavigationGuard } from '../../components'
import { GroupForm } from '../GroupForm'

interface ICreateGroupForm {
  group: IGroupDetailed
  dispatch: Dispatch
}

export const CreateGroupForm = ({ group, dispatch }: ICreateGroupForm) =>
  !group.isLoading ? (
    <Formik
      initialValues={transformRolesStateToInput({ ...initialState })}
      enableReinitialize={true}
      onSubmit={(values) =>
        dispatch(createGroup(transformRolesInputToState(values)))
      }
      render={(formikProps) => (
        <>
          <GroupForm
            formikProps={formikProps}
            submitText="Create Publishing Group"
            cancelAction={() => {
              formikProps.resetForm()
              dispatch(push('/settings/groups?tab=groups'))
            }}
          />
          <NavigationGuard isBlocking={formikProps.dirty} />
        </>
      )}
      validationSchema={groupValidationSchema}
      validateOnChange
    />
  ) : null
